import { render, staticRenderFns } from "./OrganizationAdditionalInfo.vue?vue&type=template&id=1ef38308&scoped=true&"
import script from "./OrganizationAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./OrganizationAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef38308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef38308')) {
      api.createRecord('1ef38308', component.options)
    } else {
      api.reload('1ef38308', component.options)
    }
    module.hot.accept("./OrganizationAdditionalInfo.vue?vue&type=template&id=1ef38308&scoped=true&", function () {
      api.rerender('1ef38308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/components/OrganizationAdditionalInfo.vue"
export default component.exports